import { graphql } from "../../../models/autogenerated-deliveryService-gql";

export const RequestOtpMutation = graphql(/* GraphQL */ `
  mutation requestOtp($otpInput: OtpInput!) {
    otp(input: $otpInput) {
      ...OtpPayload
    }
  }
`);
